import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import useEEActive from '../../../../hooks/useEEActive';
import CTAButton, { ctaEnums } from '../../../@shared/ctaButton';
import CustomExternalAnchor from '../../../@shared/customExternalAnchor';
import Picture from '../../../@shared/picture';
import { TGridCardProps } from '../../types/cardGrid.types';

const GridCard: FC<TGridCardProps> = ({ id, dataSource, image, mobileImage, cardHeadingTag, title, subtitle, link }) => {
  const isEE = useEEActive();
  return (
    <>
      <div className="card-grid-card__img-container">
        <Picture
          editorialImageProps={{
            id: id ?? dataSource,
            desktopImage: image,
            mobileImage: mobileImage,
            desktopTransformation: 'Size500',
            mobileTransformation: 'Size500',
          }}
        />
        {!isEE && <div className="card-grid-card__triangle"></div>}
      </div>
      <Text tag={cardHeadingTag} field={title} className="card-grid-card__title" />
      <Text tag="p" field={subtitle} className="card-grid-card__subtitle" />
      {(isEE || (link?.value?.text && link?.value?.href)) && (
        <div className="card-grid-card__cta">
          <CTAButton type={ctaEnums.primaryRed}>
            {isEE ? <CustomExternalAnchor field={link} /> : <span>{link?.value?.text}</span>}
          </CTAButton>
        </div>
      )}
    </>
  );
};

export default GridCard;
